
import {lsi} from "../../datafetcher/LSIDataFetcher";
import {InfiniteTableDataFetcher} from "../../datafetcher/InfiniteTableDataFetcher";
import {ListChildComponentProps} from "react-window";
import PDAMCellRenderer from "./PDAMCellRenderer";
import {nanoid} from "nanoid";
import {DAMSearchFilter} from "./DAMFilter";
import {PDAMFile} from "./PDAM";


export class PDAMDataFetcher implements InfiniteTableDataFetcher {

    private data: { [key:number] : PDAMFile }
    private deleteData: {[key:number]: boolean}
    private numFound: number;
    private batchSize: number;

    constructor(private path:string,
                private searchFilter:DAMSearchFilter,
                private onChangePath: (path:string) => void,
                private onSelectFile: (path:string) => void,
                private mode: "edit"|"select") {
        this.batchSize = 100;
        this.numFound = 0;
        this.data = {};
        this.deleteData = {};
    }

    getCurrentPath(): string {
        return this.path;
    }
    getBatchSize(): number {
        return this.batchSize;
    }

    getTotalRecord(): number {
        return this.numFound;
    }

    isItemLoaded(row:number): boolean {
        if(this.data[row]) return true;
        else return false;
    }

    getCellHeightAt(index:number) {
        if(this.deleteData[index]) return 0;
        else if(this.searchFilter.recursive) {
            return 60;
        } else {
            return 40;
        }
    }

    getCellRendererAt(reloadFunc: (auto:boolean,itemCount: number) => void ,props: ListChildComponentProps): JSX.Element {
        let {index} = props;
        let temp = this.data[index];
        if(temp) {
            return <PDAMCellRenderer mode={this.mode} key={nanoid()} style={props.style} damFile={temp} showSubFolder={this.searchFilter.recursive}
                                    onDelete={() => {
                                            // console.log("temp.fullPath",temp.fullPath);
                                            lsi.pdam.rm(temp.fullPath).then(() => {
                                                this.data = {};
                                                this.numFound = this.numFound-1;
                                                reloadFunc(true,this.numFound);
                                            });
                                        }
                                    }
                                    onSelectFile={this.onSelectFile}
                                    onChangePath={this.onChangePath}
                                    onRename={(oldName:string,newName: string) => {
                                            if(oldName === newName) return;
                                            let path = temp.fullPath;
                                            index = path.lastIndexOf("/");
                                            path = path.substring(0,index+1);
                                            lsi.pdam.rename(path + oldName,path + newName).then(() => {
                                               this.data = {};
                                               reloadFunc(true,this.numFound);
                                            });
                                        }
                                    }/>
        } else {
            return <PDAMCellRenderer mode={this.mode} style={props.style} showSubFolder={this.searchFilter.recursive} onChangePath={() => {}}/>
        }
    }

    getDataAt(index: number): PDAMFile {
        return this.data[index];
    }

    load() {
        let parent = this;
        return lsi.pdam.list(this.searchFilter.query,this.searchFilter.recursive,this.path).then((response) => {

                let files:PDAMFile[] = response.data.response;
                this.numFound = files.length
                for(let i=0;i<files.length;i++) {
                    parent.data[i] = files[i]
                }
                return response;
            });
    }

    loadNext(startIndex:number, endIndex: number): Promise<any> | null {
        let parent = this;
        return lsi.pdam.list(this.searchFilter.query,this.searchFilter.recursive,this.path).then((response) => {
            let files:PDAMFile[] = response.data.response;
            this.numFound = files.length
            for(let i=0;i<files.length;i++) {
                parent.data[i] = files[i]
            }
            return response;
        });
    }


}